import { getSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";

export enum ELayoutState {
    PRE_DEFINED_INDUSTRY,
    PRE_DEFINED_INDUSTRY_ALL,
    CUSTOM_INDUSTRY,
    CUSTOM_INDUSTRY_WITH_SEGMENTS,
}

export const resolveLayoutState = (): ELayoutState => {
    const category = getSelectedCategory();
    if (!category) {return ELayoutState.PRE_DEFINED_INDUSTRY;}
    const { isCustomCategory, segments = [] } = category;
    if (CategoryServiceUtils.isAll()) {return ELayoutState.PRE_DEFINED_INDUSTRY_ALL;}
    if (!isCustomCategory) {return ELayoutState.PRE_DEFINED_INDUSTRY;}
    if (segments.length > 0) {return ELayoutState.CUSTOM_INDUSTRY_WITH_SEGMENTS;}
    return ELayoutState.CUSTOM_INDUSTRY;
};
